import { isAfter } from 'date-fns'
import orderBy from 'lodash/orderBy'
import { isShelflifeCoreApp, isShelflifeBasedApp } from '../../../van-shared/utils/utils'

const isAfterDate = (date) => {
  const newDate = new Date()
  return isAfter(date, newDate)
}

const addOverduesToCurrentWeekPayments = (currentWeek, overdue) => {
  const defaultValues = { transactions: [], totaldue: 0 }

  // we only need the first items
  const overduePayments = overdue[0] || defaultValues
  const currentWeekPayments = currentWeek[0] || defaultValues

  const totalDueCurrentWeek = overduePayments.totaldue + currentWeekPayments.totaldue
  const currentWeekAndOverdueTransactions = orderBy(
    [...overduePayments.transactions, ...currentWeekPayments.transactions], ['due_date'], ['desc']
  )
  return {
    totalDueCurrentWeek,
    currentWeekAndOverdueTransactions
  }
}

export {
  isAfterDate,
  addOverduesToCurrentWeekPayments,
  isShelflifeCoreApp,
  isShelflifeBasedApp
}
